"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addTargetBlankToHyperlinksMarkdown;

var _updateMarkdownAttrs = _interopRequireDefault(require("./updateMarkdownAttrs"));

var _walkMarkdownTokens = _interopRequireDefault(require("./walkMarkdownTokens"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function addTargetBlankToHyperlinksMarkdown(tokens) {
  return (0, _walkMarkdownTokens.default)(tokens, function (token) {
    switch (token.type) {
      case 'link_open':
        token = (0, _updateMarkdownAttrs.default)(token, function (attrs) {
          return (// Adds only for external links, e.g. https://, data:
            // Don't add for internal links, e.g. #ref-1, ?q=doc
            /^[0-9A-Z_a-z]/.test(attrs.href) ? _objectSpread({}, attrs, {
              rel: 'noopener noreferrer',
              target: '_blank'
            }) : attrs
          );
        });
        break;

      default:
        break;
    }

    return token;
  });
}